export default __webpack_public_path__ + "static/media/vip-bg.ad40df63.jpg";